import gsap from 'gsap';
import { playSplitText, playFade } from '../common/help_functions';


export function initInfoSection2(element) {
    playFade('.number')
    playSplitText('.title-section', true)
    playFade('.p')
    playFade('.item')
    radiusAnimation();
}

function radiusAnimation() {
    const duration = 2;

    function returnTimeline(number) {
        const num = (360 / 4) * number;
        return gsap
            .timeline()
            .to(".dot-orbit", {
                rotate: num,
                ease: "none",
                duration: duration
            })

            .to(".dot", {
                rotate: `-${num}`,
                ease: "none",
                duration: duration
            }, "<")
            .to(".dot-cube", {
                translateZ: -100,
                rotateY: -num,
                ease: "easeInOut",
                duration: duration / 2
            }, `>-${duration / 2}`);
    }

    gsap.timeline({ repeat: -1, paused: false })
        .add(returnTimeline(1))
        .add(returnTimeline(2))
        .add(returnTimeline(3))
        .add(returnTimeline(4));

}
